/**
 * Onboarding Text Constants
 * Centralized text strings for the onboarding flow.
 */

// Email Entry Step

export const EMAIL_STEP = {
  TITLE: "Access your account",
  OR_DIVIDER: "OR",
  EMAIL_PLACEHOLDER: "example@gmail.com",
  SUBMIT_BUTTON: "Continue",
  LOGIN_LINK_PREFIX: "Already have an account?",
  LOGIN_LINK: "Log in",
} as const;

// OTP Entry Step

export const OTP_STEP = {
  TITLE: "Enter Passcode",
  DESCRIPTION_PREFIX: "We've sent an email with your verification code to:",
  CODE_LABEL: "Verification Code",
  SUBMIT_BUTTON: "Create Account",
  RESEND_PREFIX: "Didn't receive a code?",
  RESEND_LINK: "Resend Code",
  RESEND_COOLDOWN: (seconds: number) => `Resend code in ${seconds}s`,
  BACK_BUTTON_ARIA: "Go back to email entry",
} as const;

// Legal
export const LEGAL = {
  CONSENT_PREFIX: "By continuing, you agree to CherryClipz's ",
  TERMS_OF_SERVICE: "Terms of Service.",
  PRIVACY_LINE: "Read our",
  PRIVACY_POLICY: "Privacy Policy",
  // The live pages (legal/legalConstants.ts). The March 2026 PDFs in public/ are out of date.
  TERMS_URL: "/terms",
  PRIVACY_URL: "/privacy",
} as const;

// Error Messages

export const ERROR_MESSAGES = {
  // Email validation
  EMAIL_REQUIRED: "Email is required",
  EMAIL_INVALID: "Please enter a valid email address",

  // OTP validation
  OTP_EXPIRED: "This code has expired. Please request a new code.",
  OTP_TOO_MANY_ATTEMPTS: "Too many failed attempts. Please request a new code.",
  OTP_INVALID: "Invalid verification code. Please check and try again.",

  // General errors
  VERIFICATION_FAILED: "Verification failed. Please try again.",
  RESEND_FAILED: "Failed to resend code. Please try again.",
  NETWORK_ERROR: "An error occurred. Please try again.",
  CSRF_NOT_FOUND: "CSRF token not found",

  // Google SSO
  GOOGLE_LOGIN_FAILED: "Google login failed",
  GOOGLE_LOGIN_UNSUCCESSFUL: "Google login was unsuccessful",
} as const;

// Success Messages

export const SUCCESS_MESSAGES = {
  CODE_SENT: "Verification code sent successfully",
  CODE_RESENT: "New verification code sent",
} as const;

// Type Exports

export type EmailStepText = typeof EMAIL_STEP;
export type OTPStepText = typeof OTP_STEP;
export type ErrorMessageKey = keyof typeof ERROR_MESSAGES;
export type SuccessMessageKey = keyof typeof SUCCESS_MESSAGES;
